import { MfPath } from "../MFormTypes";
import { MfNode } from "../node/MfNode";

/* eslint no-restricted-syntax: "off" */

const nearestDataNode = (
  owner: MfNode,
  needDataKey: string,
): MfNode | undefined => {
  const { items = [] } = owner;
  for (const item of items) {
    const { dataKey } = item;
    if (dataKey === needDataKey) return item;
    if (!dataKey) {
      const res = nearestDataNode(item, needDataKey);
      if (res) return res;
    }
  }
  return undefined;
};

export const findDataNode = (
  owner: MfNode,
  dataPath: MfPath,
): MfNode | undefined => {
  let curNode: MfNode = owner;
  for (const key of dataPath) {
    const result = nearestDataNode(curNode, key);
    if (!result) return undefined;
    curNode = result;
  }
  return curNode;
};
